"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWIPE_NOT_CONTENT_CLASS_ELEMENTS = exports.SLIDER_STEP = exports.SWIPE_EASE = exports.SWIPE_NUMBER_500 = exports.SWIPE_NUMBER_100 = exports.SWIPE_NUMBER_50 = exports.SWIPE_NUMBER_10 = exports.SWIPE_NUMBER_2 = exports.SWIPE_CERO = exports.SWIPE_MIN_SPEED = exports.SLIDER_CLASS = exports.SWIPE_CLASS = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.SWIPE_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-carousel");
exports.SLIDER_CLASS = "".concat(exports.SWIPE_CLASS, "-items-container");
exports.SWIPE_MIN_SPEED = 1;
exports.SWIPE_CERO = 0;
exports.SWIPE_NUMBER_2 = 2;
exports.SWIPE_NUMBER_10 = 10;
exports.SWIPE_NUMBER_50 = 50;
exports.SWIPE_NUMBER_100 = 100;
exports.SWIPE_NUMBER_500 = 500;
exports.SWIPE_EASE = 0.9;
exports.SLIDER_STEP = 100;
exports.SWIPE_NOT_CONTENT_CLASS_ELEMENTS = 'null slides content div';
